<script lang="ts">
    import {Component, toNative} from 'vue-facing-decorator'
    import __OrderInfoBase, {
        OrderInfoBase as _OrderInfoBase,
    } from '@/components/account/orderServices/OrderInfoBase.vue'

    @Component({mixins: [__OrderInfoBase]})
    export class OrderInfoBase extends _OrderInfoBase {
        // ZSH: Cancellation pending Confirm button should be visible to both TO1 and supplier (hotelier)
        get isShowCancellationPendingConfirm() {
            return (
                (this.isTO1 || this.isSupplier) &&
                this.isCancellationPendingStatus &&
                this.personRole !== 'dispatcher' &&
                this.isOwnProduct &&
                this.service.serviceType !== 'EXTRASERVICE'
            )
        }

        // ZSH: Confirm and Reject buttons must be visible to supplier (hotelier) for Modification pending status
        override get isShowConfirmBtn() {
            if (this.service.serviceType === 'EXTRASERVICE') return false
            return this.ownProduct || this.isSupplier
        }

        override get isShowRejectBtn() {
            if (this.service.serviceType === 'EXTRASERVICE') return false
            if (this.service.status === 'Rejected') return false
            return this.ownProduct || this.isSupplier
        }

        // ZSH: Fix case-sensitivity issue - API returns "Modification Pending" but base class checks "Modification pending"
        override get isModificationPendingStatus() {
            return this.service.status === 'Modification pending' || this.service.status === 'Modification Pending'
        }

        // ZSH: Supplier (hotelier) should see edit, cancel, and voucher buttons for Confirmed status
        override get isShowSupplierButtons() {
            return true
        }

        override get isShowVoucherBtn() {
            return this.isTO1 && !this.isFlight
        }

        // ZSH: Edit button hidden for TO1 and supplier (hotelier) roles
        override get isShowEditLink() {
            if (this.isTO1 || this.isSupplier) return false
            if (['Rejected', 'Canceled'].includes(this.service.status)) return false
            if (this.service.status?.toLowerCase().includes('pending')) return false
            return (
                (this.service.serviceType === 'ACCOMMODATION' || this.ownProduct) &&
                this.$conf.public.account.editService &&
                this.service.serviceType !== 'EXTRASERVICE'
            )
        }

        // ZSH: Cancel button is visible to TO1 role users only; hidden on any pending status
        override get isShowCancelButton() {
            if (!this.isTO1) return false
            if (this.service.status?.toLowerCase().includes('pending')) return false
            return (
                this.service.cancellationAllowed ||
                (this.packageFlightStatus && this.packageFlightStatus === 'PRECONFIRMED') ||
                (this.service.serviceType === 'EXTRASERVICE' &&
                    this.service.status === 'Confirmed' &&
                    this.$dateFns.isAfter(this.$dateFns.parseISO(this.service.startDateTime), new Date()))
            )
        }

        override get isShowSendEmailBtn() {
            if (this.isBankFee || this.service.serviceType === 'EXTRASERVICE') {
                return false
            }
            if (
                this.isSupplier &&
                (this.isConfirmationPendingStatus ||
                    this.isModificationPendingStatus ||
                    this.isCancellationPendingStatus)
            ) {
                return false
            }

            return this.isTO1 || authStore.isTO2 || authStore.isAgency || this.isSupplier
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const __base = __OrderInfoBase as any
    export default {...toNative(OrderInfoBase), ssrRender: __base.ssrRender, __scopeId: __base.__scopeId}
</script>
